import type { RouteObject } from 'react-router-dom';
import NotFound from '@/pages/NotFound';
import HomePage from '@/pages/home/page';
import CategoryPage from '@/pages/category/page';
import ArticlePage from '@/pages/article/page';
import AboutPage from '@/pages/about/page';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/category/:slug', element: <CategoryPage /> },
  { path: '/article/:id', element: <ArticlePage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;